import { defineStore } from "pinia";
import { ref } from "vue";
import { client } from "@/main";
import router from "@/router";
export const useCustomerStore = defineStore("customers", () => {
    const customerList = ref([]);
    const selectedCustomer = ref(null);
    function setCustomer(customer) {
        if (!customer) {
            customer = { customerId: "undefined" };
        }
        selectedCustomer.value = customer;
        localStorage.setItem("selectedCustomer", JSON.stringify(selectedCustomer.value));
    }
    async function getCustomerList() {
        try {
            const { data } = await client.path("/customers").method("get").create()({
                sort: "+customerName",
                limit: 1000
            });
            customerList.value = data.data || [];
            return data.data;
        }
        catch (e) {
            console.error(e);
        }
    }
    function autoSetCustomer() {
        let selectedCustomerTmp = null;
        const savedCustomerStr = localStorage.getItem("selectedCustomer");
        if (savedCustomerStr) {
            const savedCustomer = JSON.parse(savedCustomerStr);
            if (savedCustomer) {
                selectedCustomerTmp = savedCustomer;
            }
        }
        const urlCustomerId = router.currentRoute.value.params.customerId;
        /**
         * there is different customerId in the url from local Storage
         * we must switch to the user by ID in url
         **/
        if (urlCustomerId && urlCustomerId !== selectedCustomerTmp?.customerId) {
            const newCustomer = customerList.value.filter((c) => c.customerId === urlCustomerId)[0];
            if (newCustomer) {
                selectedCustomerTmp = newCustomer;
            }
        }
        if (!selectedCustomerTmp && customerList.value.length) {
            selectedCustomerTmp = customerList.value[0] ?? null;
        }
        else if (!selectedCustomerTmp) {
            throw new Error("No customer found");
        }
        selectedCustomer.value = selectedCustomerTmp;
        localStorage.setItem("selectedCustomer", JSON.stringify(selectedCustomerTmp));
    }
    return { customerList, selectedCustomer, getCustomerList, autoSetCustomer, setCustomer };
});
